import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';
import Vehicle from '../../../models/Vehicle';

export interface CreateVehicleModalState {
    isOpen: boolean;
    vehicle?: Vehicle;
}

const initialState: CreateVehicleModalState = {
    isOpen: false,
};

export const slice = createSlice({
    name: 'createVehicleModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setVehicle: (state, action: PayloadAction<Vehicle>) => {
            state.vehicle = action.payload;
        },
    },
});

export const { setOpen, setVehicle } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) =>
    state.createVehicleModal.isOpen;
export const selectVehicle = (state: RootState) =>
    state.createVehicleModal.vehicle;

export default slice.reducer;
